export var TimesUnitId;
(function (TimesUnitId) {
    TimesUnitId["Nanosecond"] = "nanoseconds";
    TimesUnitId["Microsecond"] = "microseconds";
    TimesUnitId["Milliseconds"] = "milliseconds";
    TimesUnitId["Seconds"] = "seconds";
    TimesUnitId["Minutes"] = "minutes";
    TimesUnitId["Hours"] = "hours";
    TimesUnitId["Days"] = "days";
    TimesUnitId["Weeks"] = "weeks";
    TimesUnitId["Months"] = "months";
    TimesUnitId["Years"] = "years";
    // deprecated
    TimesUnitId["ms"] = "ms";
    TimesUnitId["s"] = "s";
    TimesUnitId["min"] = "min";
    TimesUnitId["hour"] = "hour";
    TimesUnitId["day"] = "day";
    TimesUnitId["week"] = "week";
})(TimesUnitId || (TimesUnitId = {}));
export var times = [
    {
        id: TimesUnitId.Nanosecond,
        alias: ["ns", "nanoseconds(ns)"],
        divisor: 1,
        display: "ns",
    },
    {
        id: TimesUnitId.Microsecond,
        alias: ["μs", "microseconds(μs)"],
        divisor: 1000,
        display: "μs",
    },
    {
        id: TimesUnitId.Milliseconds,
        alias: ["ms", "milliseconds(ms)"],
        divisor: 1000 * 1000,
        display: "ms",
    },
    {
        id: TimesUnitId.Seconds,
        alias: ["s", "seconds(s)"],
        divisor: 1000 * 1000 * 1000,
        display: "s",
    },
    {
        id: TimesUnitId.Minutes,
        alias: ["min", "minutes(min)"],
        divisor: 1000 * 1000 * 1000 * 60,
        display: "min",
    },
    {
        id: TimesUnitId.Hours,
        alias: ["hour", "hours(hour)"],
        divisor: 1000 * 1000 * 1000 * 60 * 60,
        display: "hour",
    },
    {
        id: TimesUnitId.Days,
        alias: ["day", "days(day)"],
        divisor: 1000 * 1000 * 1000 * 60 * 60 * 24,
        display: "day",
    },
    {
        id: TimesUnitId.Weeks,
        alias: ["week", "weeks(week)"],
        divisor: 1000 * 1000 * 1000 * 60 * 60 * 24 * 7,
        display: "week",
    },
    {
        id: TimesUnitId.Months,
        alias: ["month", "months(month)"],
        divisor: 1000 * 1000 * 1000 * 60 * 60 * 24 * 30,
        display: "month",
    },
    {
        id: TimesUnitId.Years,
        alias: ["year", "years(year)"],
        divisor: 1000 * 1000 * 1000 * 60 * 60 * 24 * 365,
        display: "year",
    },
];
export var deprecatedTimes = [
    {
        id: TimesUnitId.ms,
        divisor: 1,
        display: "毫秒",
    },
    {
        id: TimesUnitId.s,
        divisor: 1000,
        display: "秒",
    },
    {
        id: TimesUnitId.min,
        divisor: 1000 * 60,
        display: "分",
    },
    {
        id: TimesUnitId.hour,
        divisor: 1000 * 60 * 60,
        display: "小时",
    },
    {
        id: TimesUnitId.day,
        divisor: 1000 * 60 * 60 * 24,
        display: "天",
    },
    {
        id: TimesUnitId.week,
        divisor: 1000 * 60 * 60 * 24 * 7,
        display: "周",
    },
];
//# sourceMappingURL=times.js.map